<template>
  <div>
    <Background />
    <div class="container">
      <div class="symposium_login">
        <div ref="symposiumLoginCover" class="symposium_login-cover">
          <picture>
            <source srcset="@/assets/images/symposium/symposium_login.webp" type="image/webp" />
            <source srcset="@/assets/images/symposium/symposium_login.png" type="image/png" />
            <img src="@/assets/images/symposium/symposium_login.png" alt="Symposium cover"
              class="symposium_login-cover-image" />
          </picture>
        </div>
        <div ref="symposiumLoginForm" class="symposium_login-right">
          <div class="symposium_login-form-wrapper">
            <h1 class="symposium_login-form-title" :style="{ color: isSymposiumClose ? '#797979' : '#000' }">
              {{ formTitle }} <br />
              Adman Awards & Symposium 2025
            </h1>
            <p class="symposium_login-form-sub_title">
              {{ isSymposiumClose ? '' : 'การชมย้อนหลังจะเปิดให้เข้าชมได้ตั้งแต่ วันนี้ - พฤษภาคม 2569' }}
            </p>
            <form @submit.prevent="onSubmit" class="symposium_login-form">
              <label class="symposium_login-form-label">
                <template v-if="isSymposiumClose">
                 ระบบการรับชมงานสัมมนาย้อนหลัง<br>ให้บริการตั้งแต่ วันนี้ ถึง สิ้นเดือนพฤษภาคม 2569<br>โปรดติดตามข่าวสารเพิ่มเติมได้ที่ FB: <a href="https://www.facebook.com/admanaward">Adman Awards & Symposium</a>
                </template>
                <template v-else>
                  ขอขอบคุณแขกผู้มีเกียรติทุกๆ ท่านที่มาร่วมงาน <br /> Adman Awards & Symposium 2025 <br />
                  กรุณากรอก Eventpop Code ของคุณ เพื่อรับชมคลิปย้อนหลัง
                </template>
              </label>
              <input v-model="code" type="text" placeholder="XXXXXX" maxlength="6" :class="[
                'symposium_login-form-input',
                isError ? 'symposium_login-form-input--invalid' : ''
              ]" style="text-transform: uppercase;" v-if="!isSymposiumClose" />
              <div :style="{ visibility: isError ? 'visible' : 'hidden' }" class="symposium_login-form-invalid_text">
                {{ errorText }}
              </div>
              <button type="submit" v-if="!isSymposiumClose">Submit</button>
            </form>
          </div>
          <router-link to="/" class="symposium_login-back_to_home">
            กลับสู่หน้าเว็บไซต์ Adman
          </router-link>
        </div>
      </div>
      <div class="sponsor-wapper">
        <Sponsor :onSymposiumPage="true" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    Background: () => import('@/components/Backgrounds/GradientBlackRed.vue'),
    Sponsor: () => import('@/components/Sponsor/Main')
  },

  data() {
    return {
      code: '',
      isError: false,
      errorText: ''
    }
  },

  computed: {
    ...mapState({
      symposiumAuth: state => state.symposium.auth,
      isSymposiumClose: state => state.symposium.isSymposiumClose
    }),
    formTitle() {
      return this.isSymposiumClose
        ? 'ขอขอบคุณแขกผู้มีเกียรติทุกๆ ท่านที่มาร่วมงาน'
        : 'รับชมคลิปย้อนหลังงาน'
    }
  },

  watch: {
    'symposiumAuth.isError'() {
      if (this.symposiumAuth.isError) {
        this.errorText = '*Invalid Code'
        this.isError = true
      }
    },

    code() {
      this.isError = false
      this.errorText = ''
    }
  },

  methods: {
    setWidthOfFormSide() {
      const func = () => {
        const symposiumLoginCover = this.$refs.symposiumLoginCover
        const symposiumLoginForm = this.$refs.symposiumLoginForm
        const offsetWidth = symposiumLoginCover.offsetWidth <= 520 ? 520 : symposiumLoginCover.offsetWidth

        symposiumLoginForm.style.width = `calc(100% - ${offsetWidth}px)`
        symposiumLoginForm.style.display = 'flex'
      }

      window.addEventListener('resize', func)

      func()
    },

    onSubmit() {
      if (this.code === '') {
        this.errorText = '*Please enter the code'
        this.isError = true
      } else if (this.code.length !== 6) {
        this.errorText = '*Invalid Code'
        this.isError = true
      } else {
        this.$store.dispatch('symposium/signInWithCode', this.code)
      }
    }
  },

  created() {
    this.$store.dispatch('symposium/checkForRedirectToListPage')
  },

  mounted() {
    this.setWidthOfFormSide()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.sponsor-wapper {
  width: 100%;
  background: #fff;
  padding-bottom: 50px;
}

// (100 viewport height) - ( (Height of header) + (Padding content) )
$height_symposium_content: calc(100vh - (120px + 68px));

.container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 34px;
  padding-bottom: 34px;
  // height: calc(100vh - 120px);

  @media only screen and (max-width: $break-l) {
    height: auto;
  }
}

.symposium_login {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  max-height: 600px;
  width: 100%;
  height: $height_symposium_content;
  background-color: #ffffff;

  @media only screen and (max-width: $break-l) {
    max-height: unset;
    height: auto;
    flex-direction: column;
  }

  &-cover {
    position: relative;
    padding-bottom: clamp(1px, $height_symposium_content, 600px);
    width: clamp(1px, $height_symposium_content, 600px);
    height: 0;

    @media only screen and (max-width: $break-l) {
      padding-bottom: 100%;
      width: 100%;
    }

    &-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &-right {
    overflow-y: unset;
    display: none;
    height: 100%;

    @media only screen and (max-width: $break-l) {
      overflow-y: unset;
      width: 100% !important;
    }
  }

  &-form {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 72px;
    max-width: 400px;

    &-wrapper {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      padding: 40px;
      min-height: 393px;
      width: 100%;

      @media only screen and (max-width: $break-l) {
        flex-direction: column;
        width: 100% !important;
      }
    }

    &-title {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 8px;
      max-width: 388px;
      text-align: center;
      font-weight: 700;
      font-size: 1.5rem;
      color: #000000;
    }

    &-sub_title {
      margin-bottom: 38px;
      text-align: center;
      font-size: 0.875rem;
      color: #6b6b6b;
    }

    &-label {
      font-weight: 700;
      font-size: 1.125rem;
      text-align: center;
    }

    &-input {
      padding-left: 16px;
      padding-right: 16px;
      width: 100%;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #e0e0e0;
      background-color: #e0e0e0;
      font-weight: 700;
      font-size: 1.125rem;
      color: #000000;

      &::placeholder {
        color: #ffffff;
      }

      &--invalid {
        border: 1px solid #e42200;
      }
    }

    &-invalid_text {
      height: 38px;
      color: red;
    }

    button {
      &[type="submit"] {
        padding-top: 3px;
        height: 30px;
        border-radius: 4px;
        background-color: $primary-color;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 1.125rem;
        color: #ffffff;
      }
    }
  }

  &-back_to_home {
    position: absolute;
    bottom: 40px;
    right: 40px;
    text-decoration: underline;
    font-weight: 700;
    font-size: 1.125rem;
    color: #000000;
  }
}
</style>